import { render } from "./MUpgradeVIP.vue?vue&type=template&id=25a15c8c&scoped=true"
import script from "./MUpgradeVIP.vue?vue&type=script&lang=js"
export * from "./MUpgradeVIP.vue?vue&type=script&lang=js"

import "./MUpgradeVIP.vue?vue&type=style&index=0&id=25a15c8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a15c8c"]])

export default __exports__